<div class="alert alert-dismissible custom-alert-error" *ngIf="display">
    <button type="button" (click)="closeModel()" class="close close-modified" data-dismiss="alert">
        &times;
    </button>
    <div class="login-error-text">
        <div class="error-icon"><img src="assets/images/warning.png" /></div>
        <div class="login-error-message">{{ message }}</div>
    </div>
</div>
